import React, {Component} from 'react';
import {API_URL} from "../../settings/local_settings";
import {APIClient} from "../../utils/APIClient";
import { withTranslation } from 'react-i18next';

export class SendReportLinkClass extends Component {

    constructor(props) {
        super(props);

        this.sendReport = this.sendReport.bind(this);

        this.state = {
            sending: false
        }
    }

    sendReport(event) {
        event.preventDefault();

        this.setState({sending:true});

        new APIClient(this.getUrl()).call('GET').then((data) => {
            if (data.status !== 'OK') {
                alert(data['error_message']);
                this.setState({sending:false});
            } else {
                const { t } = this.props;
                alert(t('send_report_link.report_sent_successfully'));
                this.setState({sending:false});
            }
        })
    }

    getUrl() {
        return API_URL + 'user/' + this.props.userId + '/module/marketing/reports/' + this.props.reportType + '/send/';
    }


    render() {
        const { t } = this.props;
        if(!this.state.sending)
            return <span className="ms-2 me-2 send_report_link"><a href="#" onClick={this.sendReport}>[{t('send_report_link.send_now')}]</a></span>;
        else
            return <span className="ms-2 me-2 send_report_link">...{t('send_report_link.sending')}...</span>;

    }
}

export const SendReportLink = withTranslation()(SendReportLinkClass);
export default SendReportLink;
